type OrderConditions = Array<{ message: string, tags: string[] }>;

/**
 * Returns true if the given order contains a conditon that has the given tag. Otherwise returns false.
 */
export const orderContainsConditionWithTag = (order: { conditions: OrderConditions }, tagName: string) => {
    for (const condition of order.conditions) {
        for (const thisTagName of condition.tags) {
            if (thisTagName === tagName) {
                return true;
            }
        }
    }
    return false;
};

/**
 * Returns the condition's message for the given tag and order if it exists, otherwise returns false.
 */
export const getConditionMessageByTagName = (order: { conditions: OrderConditions }, tagName: string) => {
    for (const condition of order.conditions) {
        for (const thisTagName of condition.tags) {
            if (thisTagName === tagName) {
                return condition.message;
            }
        }
    }
    return null;
};
